import CreditBundles from '../pages/CreditBundles';
import CreditManagement from '../pages/CreditManagement';
import Email from '../pages/Email';
import Info from '../pages/Info';
import Profile from '../pages/Profile';
import VerifiedVoicesSharing from '../pages/VerifiedVoicesSharing';
import VerifiedVoicesSubscription from '../pages/VerifiedVoicesSubscription';

/**
 * gets user page component
 * @param {Object} options
 * @param {string} options.path
 * @return {ReactNode}
 */
export const getUserPage = ({ path }) => {
  switch (path) {
    case 'credit-bundles':
      return <CreditBundles />;
    case 'credit-management':
    case 'user-credits': // TODO LP: remove once it is renamed in the backend
      return <CreditManagement />;
    case 'email':
      return <Email />;
    case 'info':
      return <Info />;
    case 'profile':
      return <Profile />;
    case 'verified-voices-sharing':
      return <VerifiedVoicesSharing />;
    case 'verified-voices-subscription':
      return <VerifiedVoicesSubscription />;
    default:
      return null;
  }
};
